// extracted by mini-css-extract-plugin
export var active = "_2m-d";
export var blink = "_2m-e";
export var container = "_2m-5";
export var controls = "_2m-0";
export var controlsRight = "_2m-1";
export var fakeCursor = "_2m-c";
export var hidden = "_2m-b";
export var quillContainerSmall = "_2m-7";
export var quillEditor = "_2m-6";
export var quillEditorSmall = "_2m-8";
export var quillFormatButtons = "_2m-a";
export var quillToolbar = "_2m-9";
export var removePadding = "_2m-2";
export var state = "_2m-3";
export var stateTitle = "_2m-4";